// `logger` uses built-in node functions like `fs` so never expose to the browser
const logger = null;
const loggerInstance = null;

export { logger, loggerInstance };
